import { ExternalLink } from 'lucide-react';

function WalletLink({ address }) {
  if (!address) return <span className="wallet-address">Unavailable</span>;

  return (
    <a
      className="wallet-link"
      href={`https://magiceden.io/ordinals/wallet?walletAddress=${address}`}
      target="_blank"
      rel="noopener noreferrer"
      title={address}
    >
      <span>{address}</span>
      <ExternalLink size={15} aria-hidden="true" />
    </a>
  );
}

export default WalletLink;
